// extracted by mini-css-extract-plugin
export default {"host":"Search_host__LfzEj"};